module.exports = __webpack_public_path__ + "img/turks-and-caicos.803e18a2.svg";